module.exports = __webpack_public_path__ + "img/He_Chuan.f8695ba0.png";